import { render, staticRenderFns } from "./VersionDescriptionDialog.vue?vue&type=template&id=8a180026&scoped=true"
import script from "./VersionDescriptionDialog.vue?vue&type=script&lang=js"
export * from "./VersionDescriptionDialog.vue?vue&type=script&lang=js"
import style0 from "./VersionDescriptionDialog.vue?vue&type=style&index=0&id=8a180026&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a180026",
  null
  
)

export default component.exports